import { render } from "./VisionsView.vue?vue&type=template&id=7d11af0c"
import script from "./VisionsView.vue?vue&type=script&lang=js"
export * from "./VisionsView.vue?vue&type=script&lang=js"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__